/**
 * Het verschil met onze eigen prijs, als gekleurd vlakje (US-021, US-022).
 *
 * Het percentage stond er al, maar in één kleur — en dan moet je elk getal apart lezen om te zien
 * wie onder ons zit. Rood betekent hier: de concurrent is goedkoper dan wij. De tint wordt sterker
 * naarmate het verschil groter is, want vlak rood maakt −0,8% even alarmerend als −8,9%.
 *
 * **Let op de kleurbotsing.** In de kolommen ernaast betekent rood "prijs omhoog" en groen "prijs
 * omlaag" — dat is richting. Hier betekent rood "goedkoper dan wij", en dat is dezelfde kant van het
 * teken met de omgekeerde kleur. Daarom staat dit in een eigen omlijnd vlakje met de tekst "t.o.v.
 * eigen" erbij en niet in dezelfde vorm als een wijziging: twee betekenissen mogen niet dezelfde
 * vorm dragen. En de kleur staat nooit alleen — het getal met zijn teken staat er altijd bij
 * (US-021).
 */

import { beoordeelVerschil, formatPercent } from '@prijsmonitor/shared';

import styles from './VersusEigen.module.css';

const KLASSE: Record<string, string> = {
  'goedkoper-licht': styles.goedkoperLicht as string,
  'goedkoper-midden': styles.goedkoperMidden as string,
  'goedkoper-sterk': styles.goedkoperSterk as string,
  'duurder-licht': styles.duurderLicht as string,
  'duurder-midden': styles.duurderMidden as string,
  'duurder-sterk': styles.duurderSterk as string,
  gelijk: styles.gelijk as string,
};

export function VersusEigen({
  procent,
  /** "t.o.v. eigen" erbij; uit in een kolom die die kop al heeft. */
  metToelichting = false,
}: {
  procent: number | null;
  metToelichting?: boolean;
}): React.JSX.Element {
  const oordeel = beoordeelVerschil(procent);

  if (oordeel === null || procent === null) {
    return <span className={styles.geen}>geen vergelijking</span>;
  }

  const sleutel =
    oordeel.niveau === 'gelijk'
      ? 'gelijk'
      : `${oordeel.goedkoper ? 'goedkoper' : 'duurder'}-${oordeel.niveau}`;

  return (
    <span
      className={KLASSE[sleutel]}
      title={
        oordeel.niveau === 'gelijk'
          ? 'Vrijwel gelijk aan onze prijs'
          : oordeel.goedkoper
            ? 'Goedkoper dan onze prijs'
            : 'Duurder dan onze prijs'
      }
    >
      {formatPercent(procent)}
      {metToelichting && <span className={styles.toelichting}> t.o.v. eigen</span>}
    </span>
  );
}
